import React from "react";
import { format } from "date-fns";

const TableRow = (props) => {
  const { rIndex, storage, returnAmount, reasonText, reasonDetail, createdAt } =
    props;

  const formatDate = (dateStr) => {
    try {
      return format(new Date(dateStr), "dd/MM/yyyy HH:mm");
    } catch {
      return dateStr;
    }
  };

  return (
    <tr className="text-center">
      <td className="text-center">
        {storage?.images ? (
          <div
            className="rounded overflow-hidden d-inline-block"
            style={{ width: 48, height: 48, cursor: "pointer" }}
            onClick={() => {
              if (props.onPreviewImage) {
                props.onPreviewImage(`Ảnh vé`, storage.images);
              }
            }}
          >
            <img
              src={storage.images}
              alt="Ticket"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={(e) => {
                e.target.parentElement.style.display = "none";
              }}
            />
          </div>
        ) : (
          <span className="text-muted small">-</span>
        )}
      </td>
      <td>{rIndex + 1}</td>
      <td>
        <strong>{storage?.numbers || "-"}</strong>
      </td>
      <td>
        <div className="d-flex align-items-center justify-content-center gap-2">
          {storage?.ClassicLotteryChannel?.logo && (
            <img
              src={storage.ClassicLotteryChannel.logo}
              alt={storage.ClassicLotteryChannel.name}
              className="rounded-circle border border-gray-200"
              style={{ width: "24px", height: "24px", objectFit: "cover" }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          )}
          <span>
            {storage?.ClassicLotteryChannel?.name || storage?.channelId || "-"}
          </span>
        </div>
      </td>
      <td>{storage?.ClassicResult?.resultDate || "-"}</td>
      <td>{storage?.inputAmount || 0}</td>
      <td style={{ color: "#dc3545", fontWeight: 600 }}>{returnAmount}</td>
      <td>{storage?.amount || 0}</td>
      <td>
        {reasonText}
        {reasonDetail && (
          <span style={{ fontSize: "0.85em", color: "#666" }}>
            <br />({reasonDetail})
          </span>
        )}
      </td>
      <td>{formatDate(createdAt)}</td>
    </tr>
  );
};

export default React.memo(TableRow);
